import React from 'react';
import { IconButton, Box } from '@mui/material';
import { motion } from 'framer-motion';
import { useSidebar } from '../../contexts/SidebarContext';

const SidebarToggle: React.FC = () => {
  const { isCollapsed, toggleSidebar } = useSidebar();

  return (
    <IconButton
      onClick={toggleSidebar}
      sx={{
        width: 36,
        height: 36,
        borderRadius: '10px',
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        '&:hover': {
          backgroundColor: 'rgba(74, 158, 255, 0.15)',
        },
        transition: 'all 0.2s ease',
      }}
    >
      <Box
        component={motion.div}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '4px',
          width: '18px',
          height: '18px',
        }}
      >
        <motion.span
          animate={{
            rotate: isCollapsed ? 45 : 0,
            y: isCollapsed ? 6 : 0,
          }}
          transition={{ duration: 0.2 }}
          style={{
            display: 'block',
            width: '16px',
            height: '2px',
            backgroundColor: '#fff',
            borderRadius: '2px',
          }}
        />
        <motion.span
          animate={{
            opacity: isCollapsed ? 0 : 1,
            scaleX: isCollapsed ? 0 : 1,
          }}
          transition={{ duration: 0.2 }}
          style={{
            display: 'block',
            width: '12px',
            height: '2px',
            backgroundColor: '#fff',
            borderRadius: '2px',
          }}
        />
        <motion.span
          animate={{
            rotate: isCollapsed ? -45 : 0,
            y: isCollapsed ? -6 : 0,
          }}
          transition={{ duration: 0.2 }}
          style={{
            display: 'block',
            width: '16px',
            height: '2px',
            backgroundColor: '#fff',
            borderRadius: '2px',
          }}
        />
      </Box>
    </IconButton>
  );
};

export default SidebarToggle;
